<template>
  <div>
    <div style="background-color: white; padding: 15px 0 15px 20px; text-align: left;">
      <div>
        <span>选择生产单元：</span>
        <el-select v-model="checkedCell" placeholder="请选择生产单元" style="border:1px solid #dcdfe6; width: 300px; border-radius: 4px; margin-right: 20px;">
          <el-option
            v-for="cell in listCell"
            :key="cell.id"
            :label="cell.name"
            :value="cell.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="getUserEquips()">确定</el-button>
      </div>
    </div>
    <div class="margin_top_table">
      <el-table
        :data="listEquip"
        border
      >
        <el-table-column prop="num" label="序号"></el-table-column>
        <el-table-column prop="name" label="设备名称"></el-table-column>
        <el-table-column prop="type" label="设备类型"></el-table-column>
        <el-table-column fixed="right" label="设备启停">
          <template slot-scope="scope">
            <span>开</span>
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeStatus(scope.$index,scope.row)">
            </el-switch>
            <span>关</span>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="最近一次操作时间"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listEquip: [],
      listCell: [],
      checkedCell: '',
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username')
    }
  },
  methods: {
    // 更改设备状态
    changeStatus (index, row) {
      // 获取用户信息，取id
      this.axios.get(this.$store.state.loginIp + 'admin/lists',
        {
          params: {'pageSize': 100, 'role': '2'},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.list.length; i++) {
          if (res.data.data.list[i].username === this.username) {
            this.user_id = res.data.data.list[i].id
            break
          }
        }
        let status2 = 0
        if (row.status === true) {
          status2 = 1
        }
        let formdata = new FormData()
        formdata.append('appusrid', this.user_id)
        formdata.append('equip_id', row.id)
        formdata.append('ison_fg', status2)
        this.axios.post(this.$store.state.ip + 'opt/control', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
          this.$message.success('修改成功')
        }).catch(err => {
          console.log(err)
          this.$message.warning('修改失败')
        })
      })
    },
    // 获取 所有生产单元
    getAllCell () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 生产单元下的设备
    getUserEquips () {
      console.log(this.checkedCell)
      this.axios.get(this.$store.state.ip + 'equipdef/listEquips',
        {
          params: {'cell_id': this.checkedCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip_id = res.data.data
      }).catch(err => {
        console.log(err)
      })
      this.axios.get(this.$store.state.ip + 'opt/equQuery',
        {
          params: {'cell_id': this.checkedCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip = res.data.data
        for (let i = 0; i < this.listEquip.length; i++) {
          for (let j = 0; j < this.listEquip_id.length; j++) {
            if (this.listEquip_id[j].defname === this.listEquip[i].name) {
              this.listEquip[i].id = this.listEquip_id[j].id
              break
            }
          }
          this.listEquip[i].num = i + 1
          if (this.listEquip[i].status === 0) {
            this.listEquip[i].status = false
          } else {
            this.listEquip[i].status = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.getAllCell()
  }
}
</script>

<style scoped>
  .margin_top_table {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/manualControl.vue